import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, concatMap } from 'rxjs/operators';

import { AccountClientService } from '@mode/shared/data-access-webapp';
import * as ViewedReportIdsActions from './viewed-report-ids.actions';

@Injectable()
export class ViewedReportIdsEffects {
  public loadViewedReportIds$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ViewedReportIdsActions.loadViewedReportIds),
      concatMap(({ username }) => this._accountClientService.getViewedReportIds(username)),
      map((response) => ViewedReportIdsActions.loadViewedReportIdsComplete({ ids: response['ids'] }))
    );
  });

  constructor(
    private _actions$: Actions,
    private _accountClientService: AccountClientService
  ) {}
}
